export default class AuthInitError extends Error {
    constructor(options) {
        super();
        this.name = 'AuthLoginError';
        this.message = 'Failed to validate resource owner in auth.login()';
        this.cause = options === null || options === void 0 ? void 0 : options.cause;
    }
}
